import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ContentChild
} from '@angular/core';
import { NavbarNode } from 'app/shared/model/navbar_node.model';
import { TreeModel, ITreeOptions } from '../models/tree-model.model';
import { TreeWrapperNode } from '../models/tree-wrapper-node.model';

@Component({
    selector: 'tree-root',
    templateUrl: './tree-root.component.html',
    styleUrls: ['./tree-root.component.scss'],
    standalone: false
})
export class TreeRootComponent implements OnInit, OnChanges {
  @Input() nodes: NavbarNode[] = [];
  @Input() options: ITreeOptions = {};
  
  @Output() stateChange = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Output() changeFilter = new EventEmitter<any>();

  @ContentChild('treeNodeFullTemplate', { static: false }) treeNodeFullTemplate: TemplateRef<any>;

  treeModel: TreeModel;

  ngOnInit(): void {
    this.initializeTree();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['nodes']) {
      this.initializeTree();
      // Emitir actualización cuando cambian los nodos
      if (!changes['nodes'].firstChange) {
        this.updateData.emit(this);
      }
    }
    if (changes['options'] && !changes['options'].firstChange) {
      if (this.treeModel) {
        this.treeModel.options = this.options;
      }
    }
  }

  private initializeTree(): void {
    if (this.nodes && this.nodes.length > 0) {
      this.treeModel = new TreeModel(this.nodes, this.options);
    }
  }

  onStateChange(): void {
    this.stateChange.emit(this);
  }

  trackByNodeId(index: number, node: TreeWrapperNode): any {
    return node.id;
  }
}

